import { Box, Paper, Stack, Typography } from "@mui/material";

export const cardSx = {
	borderRadius: 3,
	border: "1px solid #e8e8e8",
	boxShadow: "0 8px 32px rgba(15, 23, 42, 0.06)",
};

export const pageContainerSx = {
	width: "100%",
	minHeight: "calc(100vh - 64px)",
	px: { xs: 2, sm: 3, md: 4 },
	py: { xs: 2, sm: 2.5 },
	boxSizing: "border-box",
};

export const explorePageSx = {
	width: "100%",
	minHeight: "calc(100vh - 60px)",
	px: { xs: 2, sm: 3, md: 4 },
	py: { xs: 3, sm: 4 },
	boxSizing: "border-box",
};

export const primaryButtonSx = {
	textTransform: "none",
	fontWeight: 600,
	bgcolor: "#212121",
	"&:hover": { bgcolor: "#000" },
};

export const compactInputSx = {
	"& .MuiOutlinedInput-root": {
		borderRadius: 1.5,
		bgcolor: "#fff",
		fontSize: "0.875rem",
		"& fieldset": { borderColor: "#e0e0e0" },
		"&:hover fieldset": { borderColor: "#bdbdbd" },
		"&.Mui-focused fieldset": { borderColor: "#757575", borderWidth: 1 },
	},
	"& .MuiInputLabel-root": { fontSize: "0.8125rem" },
};

export const compactDateFieldSx = {
	width: { xs: "100%", sm: 150 },
	flexShrink: 0,
	...compactInputSx,
};

export const compactTextFieldSx = {
	maxWidth: { xs: "100%", sm: 280 },
	...compactInputSx,
};

export const compactOptionalFieldSx = {
	width: { xs: "100%", sm: 180 },
	...compactInputSx,
};

export const compactDateSlotProps = {
	textField: {
		size: "small",
		sx: compactDateFieldSx,
	},
};

export const compactTextFieldSlotProps = {
	size: "small",
	variant: "outlined",
	sx: compactTextFieldSx,
};

export function PageHero({ icon, overline = "MBO Sale Payment Working", title, description }) {
	return (
		<Paper
			elevation={0}
			sx={{
				...cardSx,
				mb: 3,
				background: "linear-gradient(135deg, #212121 0%, #424242 100%)",
				color: "#fff",
				border: "none",
			}}
		>
			<Stack
				direction={{ xs: "column", sm: "row" }}
				spacing={2}
				alignItems={{ xs: "flex-start", sm: "center" }}
				sx={{ p: { xs: 2.5, sm: 3 } }}
			>
				{icon ? (
					<Box
						sx={{
							width: 52,
							height: 52,
							borderRadius: 2.5,
							display: "grid",
							placeItems: "center",
							bgcolor: "rgba(255, 255, 255, 0.12)",
							flexShrink: 0,
							"& .MuiSvgIcon-root": { fontSize: 28 },
						}}
					>
						{icon}
					</Box>
				) : null}
				<Box minWidth={0}>
					<Typography variant="overline" sx={{ opacity: 0.85, letterSpacing: 1.2 }}>
						{overline}
					</Typography>
					<Typography variant="h5" fontWeight={700} sx={{ mt: 0.25 }}>
						{title}
					</Typography>
					{description ? (
						<Typography variant="body2" sx={{ mt: 0.75, opacity: 0.9, maxWidth: 560 }}>
							{description}
						</Typography>
					) : null}
				</Box>
			</Stack>
		</Paper>
	);
}

export function SectionCard({ title, icon, children, sx }) {
	return (
		<Paper elevation={0} sx={{ ...cardSx, p: { xs: 2, sm: 3 }, mb: 3, ...sx }}>
			{title ? (
				<Stack direction="row" alignItems="center" spacing={1} mb={2.5}>
					{icon}
					<Typography variant="h6" fontWeight={700}>
						{title}
					</Typography>
				</Stack>
			) : null}
			{children}
		</Paper>
	);
}
